import { ref } from "@vue/composition-api";
import { getElement } from "@/lib/elementHelpers";

export default function useClampingView(maxHeight: number = 200) {
  const clampingComponent = ref();
  const styleHeight = ref({});
  const expanded = ref(false);
  const showHeightToggle = ref(true);

  const toggleExpanded = () => {
    expanded.value = !expanded.value;
  };

  const clampOnMount = () => {
    const viewerElement = getElement<HTMLElement>(clampingComponent.value);
    let elementHeight = viewerElement.getBoundingClientRect().height;
    styleHeight.value = { "--contentHeight": `${elementHeight}px`, "--max-height": `${maxHeight}px` };
    showHeightToggle.value = elementHeight > maxHeight;

    const listener = (el: HTMLImageElement, event: string) => {
      el.addEventListener(
        event,
        () => {
          elementHeight = Number(viewerElement?.getBoundingClientRect().height);
          styleHeight.value = { "--contentHeight": `${elementHeight}px` };
          showHeightToggle.value = Number(viewerElement?.getBoundingClientRect().height) > maxHeight;
        },
        { once: true }
      );
    };

    viewerElement?.querySelectorAll("img").forEach(el => {
      listener(el, "error");
      listener(el, "load");
    });
  };
  return {
    clampingComponent,
    expanded,
    styleHeight,
    showHeightToggle,
    clampOnMount,
    toggleExpanded,
  };
}
